var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NotificationTypeWrapper',{attrs:{"notification":_vm.notification}},[_vm._v("\n  "+_vm._s(_vm.sendingUnionName)+" has\n  "),_c('a',{attrs:{"href":_vm.actionLink},domProps:{"textContent":_vm._s('shared an item with your organization')}}),_vm._v("\n  .\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }